import React from "react";

import Lamina20img from "../images/lamina20img.png";
import Lamina20act1 from "../images/lamina20act1.png";
import Lamina20act2 from "../images/lamina20act2.png";
import { Helmet } from "react-helmet";
import Button from "@material-ui/core/Button";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Banner from "../components/Banner";
import BannerFooter from "../components/BannerFooter";
import Title from "../components/Title";

import Actividad from "../components/Actividad";

const useStyles = makeStyles((theme) => ({
  contentLamina: {
    "& img": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& p": {
      lineHeight: 1.5,
    },
    margin: "2em auto 4em",
  },
  green: {
    color: theme.palette.green.main,
    borderColor: theme.palette.green.main,
  },
  root1: {
    width: "90%",
    margin: "-80px auto 0",
  },
  root: {
    textAlign: "center",
    "& p": {
      textAlign: "left",
    },
    "& li": {
      textAlign: "left",
    },
    "& h1": {
      textAlign: "left",
    },
    [theme.breakpoints.down("md")]: {
      "& img": {
        maxWidth: "100% !important",
      },
    },
  },
  rectangleYellow: {
    backgroundColor: "#ffcb05",
    padding: "15px 15px 15px 5px",
    transform: "rotate(-5deg)",
    fontWeight: 600,
    margin: "0 2em 2em 0",
    maxWidth: 400,
    "& ul": {
      paddingLeft: 30,
      marginTop: 0,
    },
    "& p": {
      paddingLeft: "1em",
      margin: 0,
    },
  },
  actText: {
    color: "#ec008c",
    fontWeight: 700,
    display: "flex",
    alignItems: "center",
    marginBottom: "20px",
  },
  actCircle: {
    border: "2.5px solid #ec008c",
    borderRadius: "50%",
    height: 20,
    width: 20,
    marginRight: 15,
  },
  actContent: {
    width: "calc(100% - 35px)",
  },
}));

const Lamina20 = () => {
  const classes = useStyles();
  return (
    <>
      <Helmet
        title="Ciudadanía activa - Lámina 20: La equidad de género en el Perú"
        meta={[
          {
            property: "og:title",
            content: "Lámina 20: La equidad de género en el Perú",
            dataReactHelmet: true,
          },
          {
            property: "description",
            content:
              "Hay personas que creen que las mujeres no pueden hacer las mismas actividades que hacen los hombres.",
            dataReactHelmet: true,
          },
        ]}
      />
      <Banner number="20" color="green" />

      <Container maxWidth="md" className={classes.contentLamina}>
        <Title
          title="La equidad de género en el Perú"
          color="green"
          size="md"
        />
        <Actividad color="green" />
        <p>
          <strong>Lee los siguientes diálogos entre María y Jailer.</strong>
          <br></br>Luego, reflexiona y responde las preguntas.
        </p>
        <img src={Lamina20img} alt="Actividad" />
        <Grid
          container
          className={classes.root1}
          spacing={1}
          alignItems="flex-end"
          justify="center"
        >
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <div className={classes.rectangleYellow}>
              <ul>
                <li>¿Estás de acuerdo con el papá de Jailer? ¿Por qué?</li>
                <li>¿Qué opina María sobre las profesiones?</li>
                <li>¿Estás de acuerdo con lo que dice María? ¿Por qué?</li>
              </ul>
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <p style={{ color: "#ef4136" }}>
              <strong>
                Hay personas que creen que las mujeres no pueden hacer las
                mismas actividades que hacen los hombres. También piensan que su
                opinión no es tan valiosa como la de los hombres. ¿Tú qué
                opinas?
              </strong>
            </p>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>
            Lee las siguientes oraciones y marca aquellas que alguna vez hayas
            escuchado.
          </strong>
        </p>
        <div className={classes.actText}>
          <div className={classes.actCircle}></div>
          <div className={classes.actContent}>
            Las mujeres no pueden jugar al fútbol.
          </div>
        </div>
        <div className={classes.actText}>
          <div className={classes.actCircle}></div>
          <div className={classes.actContent}>
            Las mujeres son las que deben hacer las tareas de la casa.
          </div>
        </div>
        <div className={classes.actText}>
          <div className={classes.actCircle}></div>
          <div className={classes.actContent}>
            Hay trabajos que no pueden hacer las mujeres, porque se necesita
            mucha fuerza e inteligencia.
          </div>
        </div>
        <br></br>
        <Grid
          container
          className={classes.root}
          spacing={1}
          alignItems="center"
          justify="center"
        >
          <Grid item lg={5} md={5} sm={12} xs={12}>
            <p>
              Todas estas ideas ocasionan que las mujeres no tengan las mismas
              oportunidades que los hombres y las pone en una situación de
              desigualdad. Por ello, es usual que a las mujeres se les impida
              hacer algunas cosas o que se les pague menos por hacer el mismo
              trabajo que un hombre.
            </p>
          </Grid>
          <Grid item lg={7} md={7} sm={12} xs={12}>
            <div className={classes.rectangleYellow}>
              <p>
                <strong>
                  El machismo es una forma de pensar y actuar en la que se
                  considera que el hombre es superior a la mujer; pero eso es un
                  error, pues las mujeres y los hombres son personas con
                  diversas capacidades que les permiten asumir y compartir las
                  mismas responsabilidades.
                </strong>
              </p>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <Actividad color="green" />
        <p>
          <strong>Observa las siguientes imágenes.</strong> Marca con un aspa (
          <CloseIcon fontSize="small" />) la que te parezca injusta y con un
          check (<CheckIcon fontSize="small" />) la que te parezca equitativa.
        </p>

        <Container maxWidth="md">
          <Grid
            container
            className={classes.root}
            spacing={1}
            alignItems="center"
            justify="center"
          >
            <Grid item lg={7} md={7} sm={7} xs={12}>
              <img src={Lamina20act1} alt="Actividad" />
            </Grid>
            <Grid item lg={5} md={5} sm={5} xs={8}>
              <img src={Lamina20act2} alt="Actividad" />
            </Grid>
          </Grid>
        </Container>

        <p>
          <strong>Reflexiona:</strong>
        </p>
        <ul>
          <li>¿Has visto situaciones parecidas en tu entorno?</li>
          <li>
            ¿Crees que mujeres y hombres tienen las mismas oportunidades en tu
            entorno?
          </li>
          <li>
            ¿Qué deberíamos hacer para promover la igualdad de oportunidades
            entre mujeres y hombres en nuestro entorno?
          </li>
        </ul>
      </Container>

      <Container maxWidth="md" className={classes.contentLamina}>
        <p>Descargar lámina aquí:</p>
        <Button
          href="https://fundacionmohme.org/wp-content/uploads/2020/07/Ciudadanía-Activa-Lámina-20.pdf"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          classes={{ root: classes.green }}
          className="btn-download"
          onClick={() => { window.dataLayer.push({
            'lamina': 'Lámina 20: La equidad de género en el Perú'
          }); }}
        >
          Descargar
        </Button>
      </Container>
      <BannerFooter
        active={true}
        anterior="En busca de la igualdad de oportunidades"
        anteriorEnlace="/lamina-1-19"
        siguiente="Las migraciones"
        siguienteEnlace="/lamina-1-21"
      />
    </>
  );
};

export default Lamina20;
